(function() {
'use strict';

angular
    .module('TR')
    .service('hotelSearchValidator', hotelSearchValidator);

function hotelSearchValidator(resourceService, dateUtil, occupancyService) {
    const domain = TRPCONFIG.Domain;

    const service = {
        validateTimeOfDay,
        validate
    };

    function dateFromRegexMatch(match) {
        const now = new Date();
        return match ? new Date(now.getFullYear(), now.getMonth(), now.getDate(), match[1], match[2]) : null;
    }

    function matchFromConfigString(cfg) {
       return /^([0-9]{2}):([0-9]{2})$/.exec(cfg);
    }

    const dateFromConfig = _.flowRight(dateFromRegexMatch, matchFromConfigString);

    function validateTimeOfDay(departureDate) {
        const now = new Date();
        const msg = null;

        if (dateUtil.sameDay(now, departureDate)) {
            const start = dateFromConfig(domain.SameDaySearchStart);
            const end = dateFromConfig(domain.SameDaySearchEnd);

            if (start && end) {
                if (now > end || now < start) {
                    return String.format(resourceService.get('SAMEDAYBOOKINGOUTOFRANGE'), domain.SameDaySearchStart, domain.SameDaySearchEnd);
                }
            } else if (start) {
                if (now < start) {
                    return String.format(resourceService.get('SAMEDAYBOOKINGTOEARLY'), domain.SameDaySearchStart);
                }
            } else if (end) {
                if (now > end) {
                    return String.format(resourceService.get('SAMEDAYBOOKINGTOLATE'), domain.SameDaySearchEnd);
                }
            }
        }
        return msg;
    }

    function validate(destination, departureDate, returnDate, searchArea, occupancy) {
        const errors = [];
        if (_.isEmpty(destination) && searchArea == null) {
            errors.push(resourceService.get('SELECTDESTINATION'));
        }
        if (destination && destination.Searchable === false) {
            errors.push(String.format(resourceService.get('NONSEARCHABLE'), destination.Title));
        }

        if (departureDate == null) {
            errors.push(resourceService.get('SELECTCHECKIN'));
        } else {
            const timeValidation = service.validateTimeOfDay(departureDate);
            if (timeValidation) {
                errors.push(timeValidation);
            }
            const now = new Date();
            const zNow = dateUtil.zeroTime(now).getTime();
            const zDep = dateUtil.zeroTime(departureDate).getTime();
            if (zDep < zNow) { //departure is in the past
                errors.push(resourceService.get('CHECKINCANNOTBEPAST'));
            }
        }

        if (returnDate == null) {
            errors.push(resourceService.get('SELECTCHECKOUT'));
        }

        if (returnDate != null && departureDate != null && returnDate <= departureDate) {
            errors.push(resourceService.get('CHECKOUTAFTERCHECKIN'));
        }

        if (!occupancyService.childAgesPopulated(occupancy)) {
            errors.push(resourceService.get('CHILDAGESERROR'));
        }

        return errors;
    }

    return service;
}
})();
